// extracted by mini-css-extract-plugin
export default {"cls1":"BWrEE0QjhEYUyWU0m87I","cls2":"dwzPh7Uqua2XvFF4XMZQ BWrEE0QjhEYUyWU0m87I"};